import { IProviderConfig } from '../../services/common/provider-config'
import { Entity } from '../entity'

export interface IAnalyticsConfiguration {
    brand: string
    debug?: string
    division?: string
    domain: string
    provider: IProviderConfig
    vendor?: string
}

export class AnalyticsConfiguration extends Entity implements IAnalyticsConfiguration {
    public brand: string
    public debug?: string
    public division?: string
    public domain: string
    public provider: IProviderConfig
    public vendor?: string

    public fromJson(jsonObject: object): IAnalyticsConfiguration {
        super.fromJson(jsonObject)

        // parse provider object
        this.provider = (jsonObject as this).provider

        return this
    }
}
